import { toValues } from "@suse-o11y/to-values";
import { type QueryParamConfig, decodeEnum, encodeString } from "serialize-query-params";

export enum DashboardFilter {
	Owned = "owned",
	Starred = "starred",
	Shared = "shared",
	All = "all",
}

const DEFAULT_DASHBOARD_FILTER = DashboardFilter.Owned;

export const dashboardFilterParam = {
	encode: (value) => {
		if (value === DEFAULT_DASHBOARD_FILTER) {
			return undefined;
		}

		return encodeString(value);
	},

	decode: (input) => decodeEnum(input, toValues(DashboardFilter)) ?? DEFAULT_DASHBOARD_FILTER,
} satisfies QueryParamConfig<undefined | DashboardFilter, DashboardFilter>;
